// src/pages/calculators/WCs.jsx
export default function Planning() {
  return (
    <>
      <h1>Planning</h1>
      <p>Conservation areas. etc..</p>
    </>
  )
}
